module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "calibre6",
    attrs: {
      "id": "calibre_toc_5"
    }
  }, [_vm._v("CHAPTER FOUR")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_c('span', {
    staticClass: "s-_5f_first_20_para_20_smcaps"
  }, [_c('span', {
    staticClass: "s-t2"
  }, [_vm._v("“Come on now,”")])]), _vm._v(" "), _c('span', {
    staticClass: "s-_5f_first_20_para_20_smcaps"
  }, [_c('span', {
    staticClass: "s-t3"
  }, [_vm._v("said")])]), _vm._v(" "), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Hanson, standing over by a file cabinet in the far corner sorting through folders. “You didn’t think we were going to sit around holding our breath, did you?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Curtis hadn’t moved an inch. He remained seated at the desk directly across from Jed armed with two notepads this time. The pad on his left was covered with his previous squiggles. The one on his right was devoted to the additional set of squiggles he’d been making for the past ten minutes. In fact, every time Jed moved around in his chair or shook his head, Curtis was at it with his black Sharpie.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("As Jed figured it, the first go-around in the early morning hours was only a warm-up. The ruse of getting hold of him while it was all still fresh in his mind set him up for the real thing—today’s grilling. A two-pronged attack by a pair of rested and well-prepared officers confronting a person of interest. Jed, in turn, was actually worse off. It was all he could do to try to keep up, collect his thoughts, and, at the same time, stay awake.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Besides, Jed was no good at bandying words, and they knew it. The way they’d been going at it, he was lucky to get a word in edgewise, let alone tell them what he had to say.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("I mean, what did you expect?” Hanson said, continuing to call over to him from the file cabinet. “Here you are, back here again, even more bleary eyed and . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Disheveled,” said Curtis, in that clipped, cut-to-the-chase tone of his.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Exactly. After the time we gave you to pull yourself together. Except that a sleepless, thinking-it-over guy who doesn’t say much to begin with, turns out to be even more of an obstacle.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Keeps feeding us the same drips and drabs,” said Curtis. “The same evasions.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("In other words,” said Hanson, “now we have to pry it out of you.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("If nothing else, Jed realized Hanson had more of an edge to his voice. No longer the easygoing, friendly one. Making it obvious he was the lead detective and Curtis was the backup.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Discarding some of the material and shoving it into an empty folder, Hanson moved a bit closer. “And since you’ve left us no choice, you’d best bear in mind Detective Curtis here has a degree in psychology and is pretty good at profiling. Because half the time people have no idea why they do the things they do. So no matter how you look at it, it would be better all around if you just came out with it and told us what really happened last night.”")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("I told you what happened.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("So you say,” said Curtis while Hanson murmured, “Right, great, here we go again.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Curtis adjusted the volume on the digital voice recorder as Hanson reached over, plunked down two new printouts for Jed’s benefit and went back to the far corner.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Without missing a beat, Curtis held his Sharpie at the ready and rattled off his theory as if it was all so cut-and-dry it didn’t warrant putting up with Jed a moment longer.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("For your information, this follows an all-too-familiar pattern. Middle-aged woman on an estate with too much time on her hands. Works it out so the hired hand is comparatively young. Errant, fair-haired, blue-eyed, so much the better. There was a similar case over in Roxbury. Same set of circumstances with the husband, give or take the fact the husband was also cheating on the side, and the young man was dark-haired and didn’t have your dubious track record.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Shutting his eyes as another wave of fatigue came over him, Jed said, “Do I really have to listen to this? Besides, she wasn’t middle-aged. She was only about forty. And there was no husband or anything like it.”")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Ah,” said Curtis, “so you can string a few coherent sentences together. Good.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Curtis did a quick comparative study flipping through the old note pad, added a check mark to the new one, and went on.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("In your particular case, we have a clear downhill pattern. Over time, the estates you worked on and lived at got progressively smaller, while your brush with the law increased and your prospects became bleaker. Add to this the fire trap you’re living in, scalping electricity, on site violations cited by the fire marshal. Plus, you borrowed the trailer from a derelict wanted for breaking and entering, car theft, and other misdemeanors. Taking into account that he’s flown the coop, you were on the verge of vagrancy with no foreseeable prospects unless—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Hold on,” said Jed, glancing at Curtis. “Where are you getting this? I was just house sitting.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Returning to his spot by the file cabinet, Hanson gave Jed an incredulous look and said, “Right, sure you were.”")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("In Jed’s mind, they were obviously still relying on Road Trooper Charlie Tate’s file. While it was true Jed knew next to nothing about the junk trailer, Tate had made him well aware of his predicament. And in Curtis’s view, Jed’s record now included run-ins with any number of characters. So, even in this groggy state, it was getting clearer by the minute what they were piling on. Why not assume Jed knew perfectly well there were no zoning laws, the trailer had been abandoned by some skuzzy lowlife and you-name-it? Why not nail him to the wall and hope he’ll crack rather than put up with him any longer?")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Up to your ears and no prospects at all at this juncture,” Curtis said. “Unless, that is, you successfully latched onto the late Miss Julie Hayden. Like you said, she had no husband, boyfriend, or ex for you to worry about. Plus, as you’ve also pointed out, given the fact she was less than ten years older rather than the usual twenty or so. And since you admitted she had some kind of condition, hence the missing pills and a medical history we’re going to track down.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("She only let on a couple of days ago. Plus I also just mentioned—”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("We know, we know,” said Hanson. “Getting an alert pendant she could wear around her neck. But you didn’t see it through. Didn’t even tell her how it worked, how the base plugged into the phone jack, and all she’d have to do is push a button on the pendant to reach 911. You only saw she was suddenly needy. And was giving you some encouragement.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("What is that supposed to mean?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("A hint,” said Curtis, “of possibilities around the corner. ‘If things could be different,’ you just told us she said. Which you took to mean your prospects were looking up. Which really meant something entirely different was going on.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("It was getting so convoluted, Jed tried to wave Curtis off, but to no avail.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Look, Jed,” said Hanson, as impatient as Curtis now. “According to the phone records, the call came from her house lasting no more than twenty seconds. She had an unlisted number, which was in your wallet, and your landline number was listed in her address book. At that time of night, in the drizzle and fog, coupled with your muddy footprints")]), _c('span', {
    staticClass: "s-t8"
  }, [_vm._v("?")]), _vm._v(" "), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("I mean, why else would you tear around in your truck, barge in through the basement door, knock over everything, and dash up to her room? Why not call back?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("I tried, I told you. The phone must’ve been off the hook.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("On purpose. She didn’t want to deal with you anymore. You took what she said the wrong way. You pushed it. Maybe she found out about your past. It’s on record you’re hot tempered when you get riled. After all you did for her over the past couple of months, given your lousy situation, the way frustration builds. The least she could’ve done is let you explain how you came to this pretty pass instead of dumping you like that.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("And let’s add the missing pills,” Curtis chimed in. “The ones you picked up for her at the pharmacy. The ones you say you knew nothing about except she had to have them.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("No longer able to take where this was going, Jed got to his feet. “Look, you said to come back and come up with something. But you won’t give me a chance to open my mouth.”")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("We gave you a chance. In case you still haven’t caught on,” said Hanson, “we deal in logic. Corroboration. Details that add up.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Which includes a possible tie-in.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("With what?” asked Hanson.")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("I don’t know exactly. Maybe the Lower East Side. Maybe even that knife fight.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Thirteen years ago?” said Hanson. “Are you serious? Are we back to that?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Jed had no idea why he brought it up. In his raggedy, muddled thoughts just before dawn, something else had crossed his mind. He had a vague recollection of that showing of "), _c('span', {
    staticClass: "s-t5"
  }, [_vm._v("Rebel Without a Cause")]), _vm._v(" at the Junior Republic. Of this cocky kid who kept saying he looked like James Dean. A remark one of the Cobras’ girls had also made back in the city. After the movie, the same kid who loved the knife fight scene at the planetarium, caught up with him outside the kitchen, pulled a switchblade, and started jabbing at Jed’s chest.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Well?” said Hanson. “Speak.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("I’m working on it. I’ve been thinking back. I spent a lot of time last night thinking back.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("So what?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Fighting off another wave of fatigue, it suddenly dawned on him. “It’s like the car. Like the one Rocco drove when he left me off.”")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Who?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("The one who set me up. Lower East Side, then the Junior Republic.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Where are we now?” said Hanson. “Is this the best you can do?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("But that was as far as Jed could take it. His eyes ached like crazy, and he felt lightheaded, like he might keel over.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Go on,” said Hanson. “Was it this Rocco the thug you chased after? Is that what you’re getting at?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("No.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Was it the kid with the knife?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("No. That kid was much smaller.”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Then what are you trying to hand us?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Butting in, Curtis said, “Tangibles, Cooper. Realities like the fresh scratch marks across your cheek. Logic linked to circumstances. Not reaching and dredging up any old crap.”")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("“"), _c('span', {
    staticClass: "s-t4"
  }, [_vm._v("Is that what you think? The voice over the phone was any old crap? The vintage Lincoln Continental . . . trying to get you guys to finally . . .?”")])]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Suddenly too woozy to go on, Jed got up and left the room. He straggled away from them until he was stopped at the security door. He hit the intercom to be let out but had to wait before the dispatcher cleared it, hit the buzzer, and let him go.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("And just then, who should pull in at the curb but Road Trooper Charlie Tate. As he emerged from his cruiser, it wasn’t the swagger that got to Jed. Nor the square-jawed set to his face, buzz cut, or the way he seemed to almost burst out of his uniform. It was that constant smirk.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Tate didn’t say a word, only nodded as he passed by. The smirk widening as if to say, “End of the line, kid. You really pushed it this time.”")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Seated behind the wheel of his truck, eyes shut, waiting for the lightheaded feeling to pass, Jed had no way of knowing how much time he had before Hanson and Curtis would charge him. Had no clue why he’d been set up again, which had to be yet another link. Had no real excuse why he hadn’t seen it coming, though Miss Julie had given him plenty of signals.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Truth was, as always, he’d opted to keep things cool and not blow this opportunity. Simply do the handy work. Or come up with a plan to clear the land, put up pergolas and gazebos and promise her a meadow of wildflowers—all things she’d never get to see.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("If he could make it up to her. Though that made no sense, he was too late, and there was no way.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("But if he could put things right, if he could do it anyway. If he could keep reaching out back and forward to the Big Apple.")]), _vm._v(" "), _c('p', {
    staticClass: "p-_5f_p"
  }, [_vm._v("Having no clue at the moment forces were at work on those same mean streets. Having no idea there was actual living proof he wasn’t that far off the mark.")]), _vm._v(" "), _c('div', {
    staticClass: "calibre5",
    attrs: {
      "id": "calibre_pb_9"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f31fe5da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/index_split_005.vue
// module id = 75
// module chunks = 0